import { filterNullable } from "@-/com.npmjs.array-utils-ts";
import type { ReferenceGraphemeMorphemeSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";
import type { MorphemeInfoPanelAccordionSectionDescriptor } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._components.morpheme-info-panel-accordion";
import { useMorphemeInfoPanelLearningProgressActionsSection } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.learning-progress.__sections.actions";
import { useMorphemeInfoPanelLearningProgressForgettingCurveSection } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.learning-progress.__sections.forgetting-curve";
import { useMorphemeInfoPanelLearningProgressStatsSection } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.learning-progress.__sections.stats";

/** This tab's sections as descriptors; see the dictionary equivalent for why it lives here. */
export function useMorphemeInfoPanelLearningProgressGraphemeSections({
  graphemeCard,
}: {
  graphemeCard: ReferenceGraphemeMorphemeSlice;
}): MorphemeInfoPanelAccordionSectionDescriptor[] {
  const stats = useMorphemeInfoPanelLearningProgressStatsSection({
    infoBackCardSlice: graphemeCard,
  });
  const forgettingCurve = useMorphemeInfoPanelLearningProgressForgettingCurveSection({
    infoBackCardSlice: graphemeCard,
  });
  const actions = useMorphemeInfoPanelLearningProgressActionsSection({
    infoBackCardSlice: graphemeCard,
  });
  return filterNullable([stats, forgettingCurve, actions]);
}
